import { proxy, useSnapshot } from 'valtio'

type TrayEditState = {
  cardId: string | null
}

const trayEditState = proxy<TrayEditState>({
  cardId: null,
})

const setTrayCardEditing = (cardId: string | null) => {
  trayEditState.cardId = cardId
}

const useTrayCardEditingId = () => useSnapshot(trayEditState).cardId

export { setTrayCardEditing, useTrayCardEditingId }
